import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { apiLogin, apiLogout, apiMe, apiRegister, getToken, setToken } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // null = checking, false = unauthenticated, user object = authenticated
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    const token = getToken();
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const me = await apiMe();
      setUser(me);
    } catch {
      setToken(null);
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback(async ({ email, password }) => {
    const data = await apiLogin({ email, password });
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  const register = useCallback(async ({ email, password, name }) => {
    const data = await apiRegister({ email, password, name });
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    await apiLogout();
    setToken(null);
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
};
